import { render, staticRenderFns } from "./callForgotpass.vue?vue&type=template&id=ba54475e&scoped=true&"
import script from "./callForgotpass.vue?vue&type=script&lang=js&"
export * from "./callForgotpass.vue?vue&type=script&lang=js&"
import style0 from "./callForgotpass.vue?vue&type=style&index=0&id=ba54475e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba54475e",
  null
  
)

export default component.exports